import Link from 'next/link';
import { Page } from '@model/common';
import { TestId } from '@components/test-ids';
import React from 'react';
import { mixins } from '@styles/mixins';
import { breakpoints, mq } from '@styles/breakpoints';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { getImageUrl } from '@util/images';
import { useI18NextContext } from '@components/hooks';
import { ConditionalWrapper } from '@util/common';

const StyledLink: any = styled(Link)({});

const MercuryHolidaysLogo: any = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  height: 30,
  cursor: 'pointer',
  ...mixins(theme).defaultDropShadow.filter,
  position: 'absolute',
  left: 0,
  margin: 0,
  width: '100%',

  ['& img']: {
    maxWidth: 200,
    width: '100%',

    [mq.small]: {
      maxWidth: 245
    }
  },

  [mq.small]: {
    position: 'static',
    left: 'auto',
    width: 'auto'
  },

  [mq.medium]: {
    margin: `${theme.custom.spacing.xSmall}px 0 0 0`,
    maxWidth: 245,
    flex: 'none',
    maxHeight: 30
  }
}));

const LogoImage: any = styled.img({
  flex: '1 0 auto'
});

export interface LogoProps {
  disableLink?: boolean;
  logoDarkUrl: string;
}

export const Logo = ({ disableLink, logoDarkUrl }: LogoProps) => {
  const url: string = logoDarkUrl;
  const t = useI18NextContext();

  if (!url) return null;

  return (
    <MercuryHolidaysLogo data-testid={TestId.navBar.logo}>
      <ConditionalWrapper
        condition={!disableLink}
        wrapper={(children) => (
          <StyledLink prefetch={false} href={Page.HOME} passHref>
            {children}
          </StyledLink>
        )}
      >
        <LogoImage
          src={getImageUrl(url, breakpoints.medium, true)}
          alt={t('common__brand_logo_alt')}
          width={200}
          height={30}
        />
      </ConditionalWrapper>
    </MercuryHolidaysLogo>
  );
};
